module.exports = __webpack_public_path__ + "static/media/sketch-02.d31ffa7b.png";